// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"8c5a36d2","462":"00cde083","478":"83e8c864"}[chunkId] + ".chunk.css";
};